var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ExpandableInputBase',{attrs:{"value":_vm.value,"staticSize":true}},[[_c('input',{class:{ 'el-input__inner': true, clickable: true },attrs:{"disabled":true,"size":"4"},domProps:{"value":_vm.value}}),_c('img',{attrs:{"src":require("../../assets/pen.svg")}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }